<template>
  <div class="data-overview">
    <!-- 表单 -->
    <el-form ref="elForm" :model="formData" inline label-width="auto">
      <el-form-item label="日期" prop="daterange">
        <el-date-picker
          v-model="formData.daterange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="销售人员" prop="salesPerson">
        <el-input v-model="formData.salesPerson" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" @click="handleSubmitForm">查询</el-button>
        <el-button :loading="loading" @click="handleResetForm">重置</el-button>
      </el-form-item>
    </el-form>

    <div v-loading="loading" class="content">
      <div class="data-list">
        <div v-for="(item, index) in dataList" :key="index" class="data-card">
          <div class="card-header">
            <span class="card-title">{{ item.label }}</span>
          </div>
          <div class="card-value">{{ item.value.toLocaleString() }}</div>
        </div>
      </div>

      <div class="charts">
        <div v-for="(item, index) in chartList" :key="index" class="pie-card">
          <div class="card-title">{{ item.title }}</div>
          <div class="chart">
            <flexible-chart ref="chart" :option="item.option"></flexible-chart>
          </div>
        </div>
        <div class="pie-card">
          <div class="card-title">功能性食品三级类目细分</div>
          <div class="chart">
            <el-table class="table" :data="tableData" height="100%" border stripe>
              <el-table-column prop="rank" label="排名" align="center" width="50"></el-table-column>
              <el-table-column prop="categoryName" label="功能分类"></el-table-column>
              <el-table-column label="定制次数" align="right">
                <template slot-scope="scope">
                  <span>{{ scope.row.count.toLocaleString() }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get_data_overview } from '@/api'
import FlexibleChart from '@/components/e-charts-v2/flexible-chart'

export default {
  name: 'data-overview',
  components: {
    FlexibleChart,
  },
  props: {},
  data() {
    return {
      formData: {},
      loading: false,
      total: 0,
      dataList: [
        {
          label: 'AI定制次数',
          value: '-',
        },
        {
          label: '定制页面点赞数',
          value: '-',
        },
        {
          label: '接待客户数',
          value: '-',
        },
      ],
      chartList: [
        {
          title: '定制功能使用情况',
          option: {
            series: [
              {
                type: 'pie',
                data: [],
                name: '定制功能使用情况',
              },
            ],
          },
        },
        {
          title: '自主备案产品定制情况',
          option: {
            series: [
              {
                type: 'pie',
                data: [],
                name: '自主备案产品定制情况',
              },
            ],
          },
        },
        {
          title: '功能性食品二级类目',
          option: {
            series: [
              {
                type: 'pie',
                data: [],
                name: '功能性食品二级类目',
              },
            ],
          },
        },
      ],
      tableData: [],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.handleSubmitForm()
  },
  beforeDestroy() {},
  methods: {
    setOption() {
      for (let i = 0; i < this.chartList.length; i++) {
        this.$refs.chart[i].setOption()
      }
    },

    // 表单查询
    handleSubmitForm() {
      this.get_data_overview()
    },

    // 重置表单
    handleResetForm() {
      this.$refs.elForm.resetFields()
      this.get_data_overview()
    },

    setChartData(data, index) {
      const list = Object.entries(data)

      this.chartList[index].option.series[0].data = list.map(item => ({
        name: item[0],
        value: item[1],
      }))
    },

    // 获取表格数据
    get_data_overview() {
      this.loading = true

      const { salesPerson, daterange = [] } = this.formData
      const [startDate, endDate] = daterange || []

      get_data_overview({
        startDate: startDate ? startDate + 'T00:00:00' : '',
        endDate: endDate ? endDate + 'T23:59:59' : '',
        salesPerson,
      })
        .then(res => {
          const {
            customTotal,
            customPageLike,
            receptionCustomer,
            customFunctionUsage = {},
            selfRecordProductCustom = {},
            functionalFoodsSecondary = {},
            functionalFoodsThird = [],
          } = res || {}

          this.tableData = functionalFoodsThird.map((item, index) => {
            return {
              ...item,
              count: (item.count || 0) - 0,
              rank: index + 1,
            }
          })

          this.dataList[0].value = customTotal
          this.dataList[1].value = customPageLike
          this.dataList[2].value = receptionCustomer

          this.setChartData(customFunctionUsage, 0)
          this.setChartData(selfRecordProductCustom, 1)
          this.setChartData(functionalFoodsSecondary, 2)
          this.setOption()
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  padding: 10px;
}

.data-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  .data-card {
    width: 300px;
    background: linear-gradient(135deg, #e0f7fa, #ffffff);
    border-radius: 16px;
    padding: 24px 20px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
    // cursor: pointer;
  }

  .data-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.08);
  }

  .card-header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
  }

  .card-title {
    font-size: 16px;
    font-weight: 500;
    color: #00796b;
  }

  .card-value {
    font-size: 36px;
    font-weight: 700;
    color: #004d40;
    text-align: center;
  }
}

.charts {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
  .pie-card {
    width: 400px;
    height: 420px;
    background: linear-gradient(135deg, #f1f8e9, #ffffff);
    border-radius: 16px;
    padding: 15px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.06);
    display: flex;
    flex-direction: column;
  }

  .card-title {
    font-size: 16px;
    font-weight: 600;
    color: #33691e;
    margin-bottom: 12px;
    text-align: center;
  }

  .chart {
    flex-grow: 1;
    min-height: 0;
  }
}
</style>
